import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import { StyledCard, TableWrapper, StyledTable, EmptyStateText } from './Styles';
import { addCommasInPrices } from './constants';
import { CategorySalesSectionProps } from './types';
import { CATEGORY_TABLE_COLUMNS, EMPTY_STATE_MESSAGES } from './constants';

const { Title } = Typography;

const CategorySalesSection: React.FC<CategorySalesSectionProps> = ({
  reportData,
}) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  if (!reportData?.categorySales?.categories || reportData.categorySales.categories.length === 0) {
    return (
      <ThemeProvider theme={theme}>
        <StyledCard title={<Title level={4} style={{ margin: 0 }}>Category Sales</Title>}>
          <EmptyStateText>{EMPTY_STATE_MESSAGES.CATEGORY_SALES}</EmptyStateText>
        </StyledCard>
      </ThemeProvider>
    );
  }

  const categories = reportData.categorySales.categories.map((category: any) => ({
    ...category,
    revenue: `$${addCommasInPrices(category.revenue || 0)}`,
    averageOrderValue: `$${addCommasInPrices(category.averageOrderValue || 0)}`,
  }));

  return (
    <ThemeProvider theme={theme}>
      <StyledCard title={<Title level={4} style={{ margin: 0 }}>Category Sales</Title>}>
        <TableWrapper>
          <StyledTable
            columns={CATEGORY_TABLE_COLUMNS}
            dataSource={categories}
            rowKey={(record, index) => `category-${index}`}
            pagination={false}
            size="middle"
          />
        </TableWrapper>
      </StyledCard>
    </ThemeProvider>
  );
};

export default CategorySalesSection;
